import React from 'react';

const projects = [
  {
    tag: 'PADEL & SPORT', name: 'Padel Arena',
    desc: 'Club de padel premium avec système de réservation en temps réel.',
    tags: ['Réservation', 'Planning', 'Membres'],
    color: '#7C3AED', bg: 'linear-gradient(135deg, #3D1A6E, #7C3AED)',
    icon: '🏸',
  },
  {
    tag: 'COWORKING', name: 'WorkHub Casablanca',
    desc: 'Espace de coworking moderne au cœur de Casablanca.',
    tags: ['Showcase', 'Booking', 'Blog'],
    color: '#2563EB', bg: 'linear-gradient(135deg, #1e3a5f, #2563EB)',
    icon: '🖥️',
  },
  {
    tag: 'CAFÉ & LOUNGE', name: 'Café Sabil',
    desc: 'Café-lounge avec menu digital et gestion des réservations.',
    tags: ['Menu', 'Événements', 'Commande'],
    color: '#92400E', bg: 'linear-gradient(135deg, #7c2d12, #ea580c)',
    icon: '☕',
  },
];

export default function Portfolio() {
  return (
    <section id="portfolio" style={{
      background: '#0a0a0f', padding: '7rem 2rem',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <p style={{
            color: '#7C3AED', fontWeight: 600, fontSize: 12,
            letterSpacing: '0.15em', textTransform: 'uppercase',
            marginBottom: '1rem',
          }}>PORTFOLIO</p>
          <h2 style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800,
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            lineHeight: 1.1, letterSpacing: '-0.02em',
          }}>
            Nos <span style={{ color: '#A78BFA' }}>réalisations</span>
          </h2>
          <p style={{ color: '#8b8b9a', marginTop: '1rem', fontSize: 16, maxWidth: 480, margin: '1rem auto 0' }}>
            Les premiers projets SoftyPusher arrivent bientôt. Voici un aperçu de ce qui se prépare.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '1.5rem', marginBottom: '3rem',
        }}>
          {projects.map((p, i) => (
            <div key={i} style={{
              background: '#13131d',
              border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: 16, overflow: 'hidden',
              transition: 'all 0.3s',
            }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.borderColor = 'rgba(124,58,237,0.3)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)';
              }}
            >
              {/* Preview */}
              <div style={{
                height: 180, background: p.bg,
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', position: 'relative',
              }}>
                <div style={{
                  position: 'absolute', top: 12, right: 12,
                  background: 'rgba(0,0,0,0.5)',
                  backdropFilter: 'blur(8px)',
                  borderRadius: 20, padding: '4px 12px',
                  fontSize: 11, color: '#fff', fontWeight: 500,
                }}>Coming soon</div>
                <div style={{ fontSize: 48, opacity: 0.6 }}>{p.icon}</div>
              </div>

              <div style={{ padding: '1.5rem' }}>
                <p style={{
                  color: '#7C3AED', fontSize: 11, fontWeight: 600,
                  letterSpacing: '0.1em', textTransform: 'uppercase',
                  marginBottom: 6,
                }}>{p.tag}</p>
                <h3 style={{
                  fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '1.1rem',
                  fontWeight: 700, marginBottom: '0.6rem',
                }}>{p.name}</h3>
                <p style={{ color: '#8b8b9a', fontSize: 14, lineHeight: 1.6, marginBottom: '1rem' }}>
                  {p.desc}
                </p>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {p.tags.map(t => (
                    <span key={t} style={{
                      background: 'rgba(124,58,237,0.1)',
                      border: '1px solid rgba(124,58,237,0.2)',
                      borderRadius: 20, padding: '3px 10px',
                      fontSize: 12, color: '#A78BFA',
                    }}>{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA card */}
        <div style={{
          background: '#13131d',
          border: '1px solid rgba(124,58,237,0.2)',
          borderRadius: 16, padding: '3rem',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 40, marginBottom: '1rem' }}>🚀</div>
          <h3 style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '1.3rem',
            fontWeight: 700, marginBottom: '0.75rem',
          }}>Votre projet pourrait être ici</h3>
          <p style={{ color: '#8b8b9a', fontSize: 15, marginBottom: '1.5rem' }}>
            Soyez parmi les premiers clients SoftyPusher et bénéficiez d'un tarif de lancement exclusif.
          </p>
          <a href="#contact" style={{
            display: 'inline-block',
            background: '#7C3AED', color: '#fff',
            padding: '12px 28px', borderRadius: 10,
            textDecoration: 'none', fontWeight: 600,
            fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 15,
            transition: 'all 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = '#6D28D9'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#7C3AED'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >Rejoindre les premiers →</a>
        </div>
      </div>
    </section>
  );
}
